(ns admin.components.composite.moment-editor.edit.video.placement-and-behavior
  (:require
   [applied-science.js-interop :as j]
   [re-frame.core :as re-frame]
   [reagent-form.core :as rf]
   [reagent-form.utils :as rfu]
   [potpuri.core :as pot]

   [admin.events.moments :as >moments]
   [admin.components.forms.fields.toggle :as toggle]
   [admin.components.forms.fields.time-marker :as time-marker]

   [kyber.components.base.text :as text]
   [kyber.styles.core :refer [gs]]))

(defn render [{:keys [moment editor-state dispatch-local]}]
  (let [{:keys [curriculum-uuid activity-uuid duration]}
        @editor-state
        update-moment-event ::>moments/update-moment
        is-updating (re-frame/subscribe [:request/is-dispatching update-moment-event])]
    (fn []
      (let [{:moment/keys [hide-at display-at start-time end-time]}
            @moment

            on-hide-at-change
            #(let [display-at (rfu/get-field-value @%1 :display-at)
                   end-time (rfu/get-field-value @%1 :end-time)]
               (when (< %2 display-at)
                 (rfu/update-field-value! %1 :display-at %2))
               (when (> %2 end-time)
                 (rfu/update-field-value! %1 :end-time %2)))

            on-display-at-change
            #(let [hide-at (rfu/get-field-value @%1 :hide-at)
                   start-time (rfu/get-field-value @%1 :start-time)]
               (when (> %2 hide-at)
                 (rfu/update-field-value! %1 :hide-at %2))
               (when (< %2 start-time)
                 (rfu/update-field-value! %1 :start-time %2)))]
        [:div {:style {:padding (gs [:spacing :p20])
                       :padding-top (gs [:spacing :p0])}}
         ;; TODO Move into form, closer to marker controls
         (when (true? (:moment-location-invalid @editor-state))
           [text/caption-10 :p
            {:style {:color (gs [:colors :error-500])}}
            (str "Moment display times cannot overlap with other "
                 "moment display times.")])

         [rf/form {:id update-moment-event
                   :is-submitting is-updating
                   :on-initialized #(dispatch-local
                                     [:set-temp-moment-form-state (:form-state %)])
                   :on-change #(do
                                 (dispatch-local [:set-dirty (rfu/form-dirty? %)])
                                 (dispatch-local
                                  [:set-moment-location-invalid
                                   {:uuid (:moment/uuid @moment)
                                    :marker-props (pot/assoc-if
                                                   {}
                                                   :start-time (-> @% :start-time :data)
                                                   :end-time (-> @% :end-time :data)
                                                   :display-at (-> @% :display-at :data)
                                                   :hide-at (-> @% :hide-at :data))}]))}
          [:form
           {:rf/form
            {:on-submit
             (fn [{:keys [hide-at display-at start-time end-time shout]}]
               (if-not (-> @editor-state :moment-location-invalid true?)
                 (re-frame/dispatch
                  [update-moment-event
                   (cond-> {:moment/uuid (:moment/uuid @moment)
                            :moment/activity {:activity/uuid activity-uuid}
                            :moment/curriculum {:curriculum/uuid curriculum-uuid}
                            :moment/display-at display-at
                            :moment/hide-at (or hide-at display-at)
                            :moment/start-time start-time
                            :moment/end-time end-time}

                     (some? shout)
                     (assoc :moment/behavior (if shout "shout" "whisper")))
                   {:plo-type "video"
                    :on-success-toast "Placement & behavior udpated"
                    :on-success #(dispatch-local [:set-dirty false])}])
                 (re-frame/dispatch >moments/overlapping-moment-message)))}}
           (when (= "note" (:moment/type @moment))
             [:<>
              [text/caption-30 :label "Pause video when moment appears"]
              (rf/custom-field
               {:field-key
                :shout

                :render
                toggle/render

                :on-change
                (fn [is-shout form-state]
                  (if (true? is-shout)
                    (let [display-at (rfu/get-field-value @form-state :display-at)]
                      ;; When the moment transistions to a shout the moment
                      ;; should clear the hide-at value (Setting it as the same
                      ;; time as display-at will hide the range.
                      (rfu/update-field-value! form-state :hide-at display-at))
                    (let [display-at (rfu/get-field-value @form-state :display-at)
                          end-time (rfu/get-field-value @form-state :end-time)
                          hide-at (j/call js/Math :min (+ display-at 10) end-time)]
                      ;; Defaults the whisper length to 10 seconds
                      (rfu/update-field-value! form-state :hide-at hide-at))))

                :default-value
                (= "shout" (:moment/behavior @moment))})])

           [text/caption-30 :p "When do you want the moment to display?"]

           (rf/custom-field
            {:field-key :display-at
             :render time-marker/render
             :label "Display at:"
             :duration duration
             :default-value display-at
             :on-change (fn [& args]
                          (apply on-display-at-change args)
                          (apply on-hide-at-change args))})

           (rf/custom-field
            {:field-key :hide-at
             :id :hide-at
             :render time-marker/render
             :label "Hide at:"
             :duration duration
             :default-value hide-at
             :on-change on-hide-at-change
             :hide-on #(or (= "question" (:moment/type @moment))
                           (true? (rfu/get-field-value % :shout)))})

           [:div {:style {:display :none}}
            (rf/input
             {:field-key :start-time
              :id :start-time
              :type :number
              :default-value start-time})

            (rf/input
             {:field-key :end-time
              :id :end-time
              :type :number
              :default-value end-time})]

           (rf/submit-button
            {:default-text "Save"})]]]))))
